import {AuthenticationService, Button, MenuComponent} from 'kkm-library';
import {Component, computed, inject} from '@angular/core';
import {Router, RouterModule} from '@angular/router';

@Component({
    selector: 'kkm-layout',
    imports: [MenuComponent, RouterModule],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss',
})
export class LayoutComponent {
    public authService = inject(AuthenticationService);
    public router = inject(Router);

    basebuttons: Button[] = [
        {
            routerLink: '/startseite',
            displayName: 'Home',
        },
        {
            routerLink: 'news',
            displayName: 'Berichte',
        },
        {
            routerLink: 'verein/kalender',
            displayName: 'Kalender/Termine',
        },
        {
            displayName: 'unser Verein',
            children: [
                {
                    routerLink: 'verein/vorstand',
                    displayName: 'Vorstand',
                },
                {
                    routerLink: 'verein/bootshaus',
                    displayName: 'Bootshaus',
                },
                {
                    routerLink: 'verein/anmeldung',
                    displayName: 'Anmeldung/Satzung',
                },
                {
                    routerLink: 'verein/anfahrt',
                    displayName: 'Anfahrt',
                },
            ],
        },
        {
            displayName: 'Training/Sportliches',
            children: [
                {
                    routerLink: 'training/sommertraining',
                    displayName: 'Sommertraining',
                },
                {
                    routerLink: 'training/wintertraining',
                    displayName: 'Wintertraining',
                },
            ],
        },
        {
            routerLink: 'verein/vorstand',
            displayName: 'Kontakt',
        },
    ];

    buttonsLoggedOut: Button[] = [
        {
            routerLink: 'login',
            displayName: 'Login',
        },
    ];
    buttonsLoggedIn: Button[] = [
        {
            // routerLink: 'apps/dashboard',
            click: () => this.openDashboard(),
            displayName: 'Mitgliederbereich',
        },
        // {
        //     displayName: 'Logout',
        //     click: () => this.logout(),
        // },
    ];

    buttons = computed(() => {
        let array = [...this.basebuttons, ...this.buttonsLoggedOut];

        if (this.authService.loginStatus()) {
            array = [...this.basebuttons, ...this.buttonsLoggedIn];
        }
        return array;
    });

    openDashboard(): void {
        // window.open('/apps/dashboard', "_blank");
        window.open('/apps/dashboard');
    }

    logout(): void {
        this.authService.logout();
        // this.router.navigateByUrl('/');
    }
}
